import { useState } from 'react';
import MainLayout from '../../../components/layout/MainLayout';
import NotificationCard from './components/NotificationCard';
import SettingsModal from './components/SettingsModal';
import { notificationConfigs } from './mockData';
import type { NotificationConfig } from './types';

export default function NotificationManagement() {
  const [selectedNotification, setSelectedNotification] = useState<NotificationConfig | null>(null);
  const [notifications, setNotifications] = useState<NotificationConfig[]>(notificationConfigs);

  const handleOpenSettings = (notification: NotificationConfig) => {
    setSelectedNotification(notification);
  };

  const handleCloseSettings = () => {
    setSelectedNotification(null);
  };

  const handleSaveSettings = (updatedNotification: NotificationConfig) => {
    setNotifications(prev =>
      prev.map(n => n.id === updatedNotification.id ? updatedNotification : n)
    );
    setSelectedNotification(null);
  };

  const systemNotifications = notifications.filter(n => n.category === 'system');
  const verificationNotifications = notifications.filter(n => n.category === 'verification');
  const marketingNotifications = notifications.filter(n => n.category === 'marketing');

  return (
    <MainLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">通知管理</h1>
          <p className="text-sm text-gray-500 mt-1">配置系统通知的发送规则和渠道</p>
        </div>

        <div className="space-y-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-1 h-5 bg-teal-500 rounded-full"></div>
              <h2 className="text-lg font-semibold text-gray-900">系统通知</h2>
            </div>
            <div className="grid grid-cols-3 gap-5">
              {systemNotifications.map(notification => (
                <NotificationCard
                  key={notification.id}
                  notification={notification}
                  onOpenSettings={handleOpenSettings}
                />
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-1 h-5 bg-teal-500 rounded-full"></div>
              <h2 className="text-lg font-semibold text-gray-900">验证码通知</h2>
            </div>
            <div className="grid grid-cols-3 gap-5">
              {verificationNotifications.map(notification => (
                <NotificationCard
                  key={notification.id}
                  notification={notification}
                  onOpenSettings={handleOpenSettings}
                />
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-1 h-5 bg-teal-500 rounded-full"></div>
              <h2 className="text-lg font-semibold text-gray-900">营销通知</h2>
            </div>
            <div className="grid grid-cols-3 gap-5">
              {marketingNotifications.map(notification => (
                <NotificationCard
                  key={notification.id}
                  notification={notification}
                  onOpenSettings={handleOpenSettings}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {selectedNotification && (
        <SettingsModal
          notification={selectedNotification}
          onClose={handleCloseSettings}
          onSave={handleSaveSettings}
        />
      )}
    </MainLayout>
  );
}
